"use client";

import axios from "axios";
import { v4 as uuidV4 } from "uuid";

export async function downloadInBrowser(url: string) {
  const response = await axios({
    url: url,
    responseType: "blob",
  });
  const href = URL.createObjectURL(response.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = uuidV4();
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
